<template>
    <div>
            <!--Content Wrap Start-->
    <div class="kode_content">
    
        <section>
        	<div class="container" style="padding-top:5%">
            	<div class="row">
                    <!--Aside Wrap Start-->
                    <div class="col-md-4">
      
                        
                        <div class="kode_aside_cat kode_aside">
                        	<h5>List Informasi</h5>
                            <ul>
                            	<li v-for="data in list_kategori" :key="data.master_kependudukan_id"><a @click="getView(data.master_kependudukan_id)">{{data.uraian}}</a></li>
                            </ul>
                        </div>

                        
                      
 
                        
                        <!--Aside Calender Wrap Start-->
                        <div class="kode_calender kode_aside">
							<div id='calendar'></div>
						</div>
                        <!--Aside Calender Wrap End-->
                        
                        <div class="kode_aside_flicker kode_aside">
                        	<h5>Galleri Kegiatan</h5>
                        	<ul>
                            	<li v-for="data in kegiatan6" :key="data.id">
                                	<a href="javascript:void(0);" @click="push_kegiatan(data.id)">
                                		<figure>
                                    		<img :src="file_path+data.foto" alt="Image Here" style="height:90px;width:100%">
                                            <figcaption>
                                            	<i class="fa fa-plus"> </i>
                                            </figcaption>
                                    	</figure>
                                	</a>
                                </li>
                                
 
                            </ul>
                        </div>
                        
                    </div>
                    <!--Aside Wrap End-->



                	<!--News Deatail Wrap Start-->
                	<div class="col-md-8">
                        <div  v-for="data in list_data" :key="data.layanan_kependudukan_id">
                            <div class="kode_news_detail">
                                <img  :src="file_path+data.file" class="img-responsive" alt="" >
                                
                                <h4>{{data.judul}}</h4>
                                <ul>
                                    <li>by <a href="#"> <span>Disdukcapil Konsel</span> </a> &nbsp; <i class="fa fa-calendar"></i>{{convert_tgl(data.createAt)}}</li>
                                    <!-- <li> <a href="#"> <i class="fa fa-heart-o"></i>144 </a> </li>
                                    <li> <a href="#"> <i class="fa fa-comment-o"></i>49 </a> </li>
                                    <li> <a href="#"> <i class="fa fa-eye"></i>12,998 </a> </li> -->
                                </ul>
                                
                                
                            
                            </div>
                                <span v-html="data.isi"></span>

                        </div>
                        
                        
                    </div>
                    <!--News Deatail Wrap End-->
                    
                    
                    
                </div>
            </div>
        </section>
        
    </div>
    <!--Content Wrap End-->
    </div>
</template>



<script>




const ADD_URL = URL_APP + "api/v1/publish_layanan_kependudukan/";
const KEGIATAN_URL = URL_APP + "api/v1/publish_kegiatan/";



const FILE_LOAD = URL_APP+'uploads/';

export default {
  name: "web_pengumuman",
//   title: "My page title",
  data() {
    return {
        id : this.$route.params.id,
        createAt : '',
        createBy : '',
        deskripsi : '',
        isi : '',
        judul : '',
        sumber : '',
        foto : '',
        kegiatan:[],
        kegiatan6:[],


        list_kategori : [],
        list_data : [],
        master_kependudukan_id : '',



		
        HOST : URL_HOST+this.$route.fullPath,
        hest : 'http://twitter.com',
		file_path : FILE_LOAD,

    //   list_data: [],
    //   page_first: 1,
    //   page_last: 0,
    //   cari_value: ""
    };
  },

  // =============================================================== METHODS =========================================================================
  methods: {

	getView: function(id) {
      fetch(ADD_URL, {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify({
          id: id,
        })
      })
        .then(res => res.json())
        .then(res_data => {
            this.list_data = res_data;
            console.log(res_data)

       });
    },
    get_kategori : function(){
        fetch(ADD_URL + "get_Kategori", {
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        }
      })
        .then(res => res.json())
        .then(res_data => {
            this.list_kategori = res_data;
            this.master_kependudukan_id = res_data[0].master_kependudukan_id
            this.getView(this.master_kependudukan_id);
            // console.log('ssssssssssssssssssssss')
        });
    },

    getKegiatan: function() {
        fetch(KEGIATAN_URL + "getOne", {
            method: "get",
            headers: {
            "content-type": "application/json",
            },

        })
            .then(res => res.json())
            .then(res_data => {
                this.kegiatan = res_data;
                //   console.log(res_data);
            });
    },    

    getKegiatan6: function() {
        fetch(KEGIATAN_URL + "get6", {
            method: "get",
            headers: {
            "content-type": "application/json",
            },

        })
            .then(res => res.json())
            .then(res_data => {
                this.kegiatan6 = res_data;
                //   console.log(res_data);
            });
    },     

    limit_desk_kegiatan : function(text){
    return text.substring(0, 100)
    }, 

	push_kegiatan : function(id){
		this.$router.push('/isi_kegiatan/'+id);
    },
        

    to_facebook : function () {
        window.open("http://www.facebook.com/sharer.php?u="+this.HOST, '_blank');
    },
    to_twitter : function(){
        // alert(this.HOST)
        window.open("https://twitter.com/share?url="+this.HOST+"&amp;text="+this.judul, '_blank');
    },







    // ================== PAGINASI ====================
        alertku: function(type, title) {
        this.$swal({
            type: type,
            title: title,
            showConfirmButton: false,
            timer: 800
        });
        },

        btn_prev: function() {
        if (this.page_first > 1) {
            this.page_first--;
        } else {
            this.page_first = 1;
        }
        this.getView();
        },

        btn_next: function() {
        if (this.page_first >= this.page_last) {
            this.page_first == this.page_last;
        } else {
            this.page_first++;
        }
        this.getView();
        },

        cari_data: function() {
          this.getView();
        },
        onFileSelected : function(event){
            this.foto = event.target.files[0];
            console.log(this.foto);
        },
        convert_tgl : function(dateString){
			var date = new Date(dateString);
			var bulan = "";

			if (date.getMonth() == 0) {bulan = 'januari';} 
			else if (date.getMonth() == 1) {bulan = 'Februari';}
			else if (date.getMonth() == 2) {bulan = 'Maret';}
			else if (date.getMonth() == 3) {bulan = 'April';}
			else if (date.getMonth() == 4) {bulan = 'Mei';}
			else if (date.getMonth() == 5) {bulan = 'Juni';}
			else if (date.getMonth() == 6) {bulan = 'Juli';}
			else if (date.getMonth() == 7) {bulan = 'Agustus';}
			else if (date.getMonth() == 8) {bulan = 'September';}
			else if (date.getMonth() == 9) {bulan = 'Oktober';}
			else if (date.getMonth() == 10) {bulan = 'November';}
			else if (date.getMonth() == 11) {bulan = 'Desember';}
			else{bulan = ''}

          return date.getDate()+" "+bulan+" "+date.getFullYear();
        },
    // ================== PAGINASI ====================
  },
  // =============================================================== METHODS =========================================================================

  mounted() {
    this.get_kategori();
    // alert(this.$route)
    // console.log(this.HOST);
    this.getKegiatan();
	this.getKegiatan6();
  },

};



</script>


